module.exports = __webpack_public_path__ + "img/b2.c0399f8c.png";